module.exports = window
